import React from 'react';
import {Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {langService} from "../../../jwt/_services";
import LangTab from "../../../components/tabs/langTab";
import {langTagService} from "../../../jwt/_services/relations/langTagService";
import {showLoader} from "../../../components/loader/loader";


class TagLangs extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            editMode: this.props.editMode,
            disableInputs : this.props.disableInputs,
            loading: false,

            tag : this.props.tag,
            langChilds: [],
            langTagChilds: [],
        }

        this.setForm = this.setForm.bind(this);
        this.onNameChange = this.onNameChange.bind(this);

        this.getLangChilds = this.getLangChilds.bind(this);
        this.getFormulary = this.getFormulary.bind(this);
    }

    componentDidMount() {
        this.setState({ loading: true });
        // ----------------------------------
        // Establece las opciones de idioma
        // ----------------------------------
        let langChilds = [];

        langService.getAll()
            .then(langOptions => {
                if (langOptions) {
                    langOptions.map((lang, index) => {
                        const langChild = {
                            lang: lang,
                            name: '',
                            id: '',
                        };

                        langChilds.push(langChild);

                        this.setState({
                            langChilds,
                            loading: false
                        });
                    });
                } else {
                    this.setState({loading: false});
                }

            })
            .then( () => {
                // ----------------------------------
                // Consulta los idiomas guardados
                // ----------------------------------
                if (this.state.editMode){
                    this.setState({loading: true});
                    langTagService.search({id: this.state.tag?.id})
                    .then((langTagChilds) => {
                            this.setState({langTagChilds});
                        })
                    .then(() => {
                        if (this.state.langTagChilds && this.state.langTagChilds.length > 0){
                            langChilds = this.combineLangChilds(this.state.langChilds, this.state.langTagChilds);
                            this.setState({
                                langChilds,
                                loading: false
                            });
                        } else {
                            this.setState({loading: false});
                        }
                    })
                }
            }).catch(() => {
            this.setState({
                loading: false
            });
        });
    }

    setForm(editMode, showList, data) {
        this.props.setForm(editMode, showList, data)
    }

    getLangChilds(){
        const langChilds = this.combineLangChilds(this.state.langChilds, this.state.langTagChilds);

        return (langChilds ? langChilds : (this.state?.langChilds ? this.state?.langChilds : []));
    }

    changeDisabledInput(option){
        this.setState({disableInputs : option });
        this.getLangChilds(); // Refresh component
    }

    combineLangChilds(langOptions, langTagChilds, editMode){
        try {
            if (langOptions && langTagChilds && langOptions.length > 0 && langTagChilds.length > 0){
                langOptions.map((child, index) => {
                    const langTagIndex = langTagChilds.findIndex(n => n.lang.id === child.lang.id);

                    if (langTagIndex !== -1) {
                        // significa que si lo encontro
                        langOptions[index] = {
                            lang :  langTagChilds[langTagIndex].lang,
                            name :  langTagChilds[langTagIndex].name,
                            id :    langTagChilds[langTagIndex].id
                        }
                        console.log(langOptions)
                    }
                });

                return langOptions;
            }
        } catch (e) {
            console.log(e.message);
            return e.message;
        }
    }

    onNameChange(value, index, lang){

        const langIndex = this.state.langChilds.findIndex(n => n.lang.id === lang.id);

        let langChilds = this.state.langChilds.slice();

        if(langIndex === -1)
            return;

        langChilds[langIndex] = {
            lang : langChilds[langIndex].lang,
            name :  value ,
            id : langChilds[langIndex].id
        }

        // Le envia la información al componente padre
        this.props.updateItem(langChilds);

        this.setState({
            langChilds : langChilds,
            langTagChilds : langChilds
        });
    }

    getFormulary(child, index, disableInputs){
        return (
            <Form>
                <Row>
                    <Col md="12">
                        <FormGroup>
                            <Label >Nombre</Label>
                            <Input type="name" name="Name"
                                   placeholder="Ingrese nombre"
                                   value= { child.name }
                                   onChange={e => this.onNameChange(e.target.value, index, child.lang )}
                                   disabled={disableInputs}
                            />
                        </FormGroup>
                    </Col>
                </Row>
            </Form>
        );
    }

    render() {

        return (
            <div>
                {this.state.loading ? showLoader() : null}
                <Row>
                    <Col md="12">
                        <LangTab
                            key={"LangTabId"}
                            langChilds={this.state.langChilds}
                            onNameChange={this.onNameChange}
                            getLangChilds={this.getLangChilds}
                            getFormulary={this.getFormulary}
                            getDisableInputs={this.getDisableInputs}
                            disableInputs={this.state.disableInputs}
                        />
                    </Col>
                </Row>
            </div>
        );
    }

}



export default TagLangs;
